import _ from 'lodash'
import axios from 'axios';

export const state = () => ({
  loading: false,
  banner: null
})

let lastStart = null
const MIN_LOADING_TIME = 1000

export const mutations = {
  setLoading(state, value) {
    if (process.server) {
      return
    }
    if (value) {
      lastStart = new Date().valueOf()
      state.loading = value
    } else if (lastStart) {
      const duration = new Date().valueOf() - lastStart
      let timeout = MIN_LOADING_TIME - duration
      timeout = timeout < 0 ? 0 : timeout
      setTimeout(() => {
        state.loading = value
      }, timeout)
    }
  },
  setBanner(state, value) {
    state.banner = value
  }
}

export const actions = {
  async fetchBanner({ state, commit }) {

    if (state.banner) {
      return
    }

    const { data } = await axios.get('https://wp.my-smi.com/wp-json/wp/v2/pages', {
      params: {
        slug: 'banner-block'
      }
    })

    commit('setBanner', _.get(data, '[0].acf.flexible_content', []))
  }
}

export const getters = {
  loading(state) {
    return state.loading
  },
  banner(state) {
    return state.banner
  }
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
